<template>
  <v-dialog v-model="cameraStarted" width="auto" content-class="dialog-barcode">
    <v-card class="barcode-card">
      <div class="camera-container">
        <StreamBarcodeReader
          id="stream"
          v-if="cameraStarted"
          @decode="onDecode"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import * as VuetifyComponents from "vuetify/lib/components";
  import { StreamBarcodeReader } from "vue-barcode-reader";

	export default {
		name: "RecebimentoDeNotaFiscalBarcodeModal",

		components: {
      ...VuetifyComponents,
			StreamBarcodeReader
		},

    props: [ 
      "openCamera",
    ],

		data() {
			return {
        cameraStarted: false,
        barcodeData: null	
			};
		},

    watch: {
      openCamera(params){
        this.cameraStarted = params
      },
    },

		methods: {
      startCamera() {
        try {
          this.cameraStarted = !this.cameraStarted;
        } catch (error) {
          console.log('ERROR>>>>>',error)
        }
      },
      onDecode(decodedValue) {
        this.barcodeData = decodedValue;
        this.$emit("barcode", this.barcodeData);
      },
		},
	};
</script>

<style>
  .dialog-barcode {
    max-width: 100vw;
    max-height: 100vh;
    padding: 0;
  }

  .barcode-card {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    background-color: black;
  }

  .camera-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  #stream {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>